export const DashboardWelcome = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="text-center">
      <div className="w-20 h-20 bg-gradient-to-br from-teal-400 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
        <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>
      <h2 className="text-2xl font-bold text-white mb-3">Welcome to Intelligent Sales Machines!</h2>
      <p className="text-gray-400 mb-6 max-w-md mx-auto">
        Complete the onboarding setup to start building your sales machine and crushing your revenue goals.
      </p>
      <div className="inline-block px-4 py-2 bg-teal-500/10 border border-teal-500/30 rounded-lg">
        <p className="text-sm text-teal-400">
          Click the <span className="font-semibold">"Setup"</span> button in the navigation to get started
        </p>
      </div>
    </div>
  </div>
);
